import React from 'react';
import useGameStore from '../../store/gameStore';
import { INTERNATIONAL_TAX } from '../../data/taxes';
import { Globe2, CheckCircle2, ArrowRight } from 'lucide-react';

/**
 * Fiscalité — onglet International (visible en Phase 4+). Gère le n° TVA
 * intracommunautaire et explique les règles export hors-UE. Extracted from
 * Fiscalite.jsx on 28/05/2026.
 */
export default function InternationalTab() {
  const { hasEuVatNumber, requestEuVatNumber } = useGameStore();

  return (
    <div className="space-y-4">
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-4">
        <h3 className="text-sm font-semibold text-slate-200 mb-3 flex items-center gap-2">
          <Globe2 className="w-4 h-4" /> Fiscalité internationale
        </h3>

        {/* EU TVA */}
        <div className="border border-accent/40 rounded-lg p-4 mb-4 bg-accent/10/30">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-full bg-accent/15 flex items-center justify-center">
              <span className="text-sm">🇪🇺</span>
            </div>
            <div>
              <p className="text-sm font-bold text-foreground">{INTERNATIONAL_TAX.eu.label}</p>
              <p className="text-[10px] text-slate-500">TVA intracommunautaire</p>
            </div>
          </div>
          <p className="text-xs text-slate-400 mb-3">{INTERNATIONAL_TAX.eu.description}</p>

          <div className="bg-ink-800 rounded-lg p-3 mb-3">
            <div className="flex items-center justify-between text-xs">
              <span className="text-slate-500">N° TVA intracommunautaire</span>
              {hasEuVatNumber ? (
                <span className="text-money flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Actif</span>
              ) : (
                <button
                  onClick={requestEuVatNumber}
                  className="text-xs bg-accent text-white px-2 py-1 rounded font-medium hover:bg-accent-hover"
                  data-testid="request-eu-vat-btn"
                >
                  Demander (200 €)
                </button>
              )}
            </div>
          </div>

          <div className="text-xs text-slate-500 space-y-1">
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-accent" /> Autoliquidation TVA sur prestations B2B UE</p>
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-accent" /> Pas de TVA facturée au client européen</p>
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-money" /> Prime revenus : +{Math.round((INTERNATIONAL_TAX.eu.revenueBonus - 1) * 100)}% sur contrats UE</p>
          </div>
        </div>

        {/* Non-EU Export */}
        <div className="border border-warn/40 rounded-lg p-4 bg-warn/5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-full bg-warn/15 flex items-center justify-center">
              <Globe2 className="w-4 h-4 text-warn" />
            </div>
            <div>
              <p className="text-sm font-bold text-amber-800">{INTERNATIONAL_TAX.nonEu.label}</p>
              <p className="text-[10px] text-slate-500">Exportations & Douanes</p>
            </div>
          </div>
          <p className="text-xs text-slate-400 mb-3">{INTERNATIONAL_TAX.nonEu.description}</p>

          <div className="text-xs text-slate-500 space-y-1">
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-warn" /> Exonération TVA sur exports</p>
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-danger" /> Droits de douane : {(INTERNATIONAL_TAX.nonEu.customsDutyRate * 100)}%</p>
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-warn" /> Délai supplémentaire : +{INTERNATIONAL_TAX.nonEu.transitTime} jours (douane)</p>
            <p className="flex items-center gap-1"><ArrowRight className="w-3 h-3 text-money" /> Prime revenus : +{Math.round((INTERNATIONAL_TAX.nonEu.revenueBonus - 1) * 100)}% sur contrats export</p>
          </div>
        </div>
      </div>
    </div>
  );
}
